import axiosInstance from "@/api/axios-instance";

export async function updatePreferredProfessional(
  usage_id: string,
  user_id: string,
  professional_id: string | null,
  is_transition = false,
) {
  const response = await axiosInstance.patch(
    `/usage/${usage_id}/preferred-professional`,
    { user_id, professional_id, is_transition },
  );

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update preferred professional");
  }

  return response.data;
}
